import { request } from './api-client';
import type {
  PlanEntitlement,
  SubscriptionPlanSummary,
} from './types';

export async function listPlans(): Promise<{ data: SubscriptionPlanSummary[] }> {
  return request('/subscription-management/plans');
}

export async function createPlan(payload: {
  tier: SubscriptionPlanSummary['tier'];
  name: string;
  description: string;
  monthlyPrice: number;
  annualDiscountPercent: number;
  sortOrder: number;
  isActive: boolean;
}) {
  return request('/subscription-management/plans', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function updatePlanEntitlements(
  planId: string,
  entitlements: Array<Pick<PlanEntitlement, 'featureKey' | 'enabled' | 'limit'>>,
) {
  return request(`/subscription-management/plans/${planId}/entitlements`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entitlements }),
  });
}

export async function syncPlanToStripe(planId: string) {
  return request(`/subscription-management/plans/${planId}/sync-stripe`, {
    method: 'POST',
  });
}

export async function setPlanActiveState(planId: string, isActive: boolean) {
  return request(`/subscription-management/plans/${planId}/activate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ isActive }),
  });
}
